import { apiFetchBalanceZones } from '../api/Pioneer/endpoints/logisticElements/logisticElements.api';
import { BalanceZoneStoreModel } from '../redux';
import { mapBalanceZonesToStore } from '../redux/store.mapper';

export const fetchBalanceZones = async (): Promise<BalanceZoneStoreModel[]> => {
  return await apiFetchBalanceZones().then(res => mapBalanceZonesToStore(res));
};
